import Component from '../abstracts/Component';
import MenuItem from './header/MenuItem';
import Cookies from 'js-cookie';
import _, { forEach } from 'lodash';
import { doAjax } from '../utils/ajaxUtil';
import FixBody from '../utils/FixBody';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocusOnModalUtils';

export default class HeaderComponent extends Component {
  get SELECTORS() {
    return {
      burgerMenu: '[data-trigger-menu]',
      searchBtn: '[data-trigger-search]:not(.mobile)',
      searchBtnMobile: '[data-trigger-search].mobile',
      layersContainer: '[data-menu-layers]',
      menuItems: '[data-menu-item]',
      hpHero: '[data-hph-item]',
      benefitBar: '[data-benefit-bar]',
      headerNav: '.c-m-h__menu-wrapper',
      formInput: '.l-quick-account .l-acc__form__input',
      popupLoginContainer: '.l-quick-account',
      keyboardToggleButtons: '[data-keyboard-toggle]',
      headerRightBar: '.c-m-h__menu-wrapper .c-m-h__actions.actions__right',
      minicartBtn: '[data-minicart-button]',
      minicartContent: '[data-minicart-content]',
      minicartCount: '[data-minicart-count]',
      minicartContentNotify: '[data-minicartnotification-content]',
      minicartMobile: '[data-minicart-mobile]',
      miniaccountEmail: '#m_username',
      miniaccountPwd: '#m_password',
      miniaccountSubmit: '#m_submit',
      wishlistLink: ".wishlist"
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      jsHeightHeader: '--js-header-height',
      jsVh: '--vh',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      burgerOpen: 'menu-open',
      showMenu: 'show-menu',
      activeLayersContainer: 'active-layers',
      divider: 'header-divider',
      minicartEmpty: 'mini-cart--empty',
      minicartFull: 'mini-cart--full',
      minicartCounterLive: 'live',
      minicartCounterGoingOut: 'goingOut',
      minicartVisible: 'visible',
      minicartOpened: 'minicart-opened',
      minicartHidden: 'hidden',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.burgerMenu = this.$component.querySelector(this.SELECTORS.burgerMenu);
    this.searchBtn = this.$component.querySelectorAll(this.SELECTORS.searchBtn);
    this.searchBtnMobile = this.$component.querySelector(this.SELECTORS.searchBtnMobile);
    this.headerNav = this.$component.querySelector(this.SELECTORS.headerNav);
    this.menuIsOpen = false;
    this.headerHeight = this.$component.offsetHeight;
    this.layersContainer = this.$component.querySelector(
      this.SELECTORS.layersContainer
    );
    if (this.layersContainer != null) {
      this.layersContainer.style.transition = 'opacity .5s ease-in-out .2s';
    }
    this.menuItems = [];
    this.hpHero = document.querySelector(this.SELECTORS.hpHero);
    this.benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    this.minicartBtn = this.$component.querySelectorAll(this.SELECTORS.minicartBtn);
    this.minicartContent = this.$component.querySelectorAll(this.SELECTORS.minicartContent);
    this.minicartCount = this.$component.querySelectorAll(this.SELECTORS.minicartCount);
    this.minicartContentNotify = this.$component.querySelectorAll(this.SELECTORS.minicartContentNotify);
    this.minicartMobile = document.querySelector(this.SELECTORS.minicartMobile);

    this.miniaccountEmail = document.querySelectorAll(this.SELECTORS.miniaccountEmail);
    this.miniaccountPwd = document.querySelectorAll(this.SELECTORS.miniaccountPwd);
    this.miniaccountSubmit = document.querySelector(this.SELECTORS.miniaccountSubmit);
    this.keyboardToggleButtons = document.querySelectorAll('[data-keyboard-toggle]');
    this.#initializeLayersAccessibility();
    this.initKeyboardNavigation();
    this.initHoverEvents();
  }

  #initializeLayersAccessibility() {
    const accountLayers = document.querySelectorAll('.l-quick-account');
    const cartLayers = document.querySelectorAll('.l-quick-cart');

    [...accountLayers, ...cartLayers].forEach(layer => {
      // Inizializza solo gli attributi necessari per la navigazione da tastiera
      layer.setAttribute('data-keyboard-accessible', 'false');
    });
  }


  initHoverEvents() {
    // Trova le icone account e cart
    const accountIcons = document.querySelectorAll('.icon-account');
    const cartIcons = document.querySelectorAll('.icon-cart');

    // Gestisci hover per icone account
    accountIcons.forEach(icon => {
      // Trova il contenitore dell'account per identificare il layer corrispondente
      const accountContainer = icon.closest('.c-m-h__actions__desk-account');
      if (accountContainer) {
        const accountLayer = accountContainer.querySelector('.l-quick-account');
        
        if (accountLayer) {
          this.#setupIconHoverEvents(icon, accountLayer, accountContainer);
        }
      }
    });

    // Gestisci hover per icone cart
    cartIcons.forEach((icon, index) => {
      // Trova il contenitore del cart per identificare il layer corrispondente
      const cartContainer = icon.closest('.c-m-h__actions__desk-mini-cart');
      
      if (cartContainer) {
        // Per il cart, il layer è dentro [data-minicart-content]
        const minicartContentDiv = cartContainer.querySelector('[data-minicart-content]');
        
        if (minicartContentDiv) {
          // Il layer può non esistere ancora, quindi aggiungiamo un observer o gestiamo dinamicamente
          this.#setupCartIconHoverEvents(icon, minicartContentDiv, cartContainer);
        }
      }
    });
  }

  #setupIconHoverEvents(icon, layer, container) {
    let hoverTimeout;

    icon.addEventListener('mouseenter', () => {
      if (!layer.hasAttribute('data-opened-by-keyboard')) {
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        
        // Attiva il layer come fa la navigazione da tastiera
        layer.classList.add('active');
        layer.setAttribute('data-opened-by-mouse', 'true');
      }
    });

    // Mouseleave sull'icona: prepara la chiusura del layer (con delay)
    icon.addEventListener('mouseleave', () => {
      if (layer.hasAttribute('data-opened-by-mouse')) {
        // Delay prima di chiudere per permettere al mouse di spostarsi sul layer
        hoverTimeout = setTimeout(() => {
          if (layer.hasAttribute('data-opened-by-mouse')) {
            layer.classList.remove('active');
            layer.removeAttribute('data-opened-by-mouse');
          }
        }, 100);
      }
    });

    // Mouseenter sul layer: cancella la chiusura programmata
    layer.addEventListener('mouseenter', () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
    });

    // Mouseleave dal layer: chiudi il layer
    layer.addEventListener('mouseleave', () => {
      if (layer.hasAttribute('data-opened-by-mouse')) {
        layer.classList.remove('active');
        layer.removeAttribute('data-opened-by-mouse');
      }
    });

    // Mouseenter sull'intero contenitore: gestisce i casi edge dove il mouse si sposta rapidamente
    container.addEventListener('mouseenter', () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
    });

    // Mouseleave dall'intero contenitore: assicura la chiusura
    container.addEventListener('mouseleave', () => {
      if (layer.hasAttribute('data-opened-by-mouse')) {
        hoverTimeout = setTimeout(() => {
          if (layer.hasAttribute('data-opened-by-mouse')) {
            layer.classList.remove('active');
            layer.removeAttribute('data-opened-by-mouse');
          }
        }, 50);
      }
    });
  }

  #setupCartIconHoverEvents(icon, minicartContentDiv, container) {
    let hoverTimeout;

    const findCartLayer = () => minicartContentDiv.querySelector('.l-quick-cart');
    const clearHoverTimeout = () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
    };

    // close layer
    const closeCartLayer = (delay = 0) => {
      const cartLayer = findCartLayer();
      if (cartLayer && cartLayer.hasAttribute('data-opened-by-mouse')) {
        if (delay > 0) {
          hoverTimeout = setTimeout(() => {
            const currentCartLayer = findCartLayer();
            if (currentCartLayer && currentCartLayer.hasAttribute('data-opened-by-mouse')) {
              currentCartLayer.classList.remove('active');
              currentCartLayer.removeAttribute('data-opened-by-mouse');
            }
          }, delay);
        } else {
          cartLayer.classList.remove('active');
          cartLayer.removeAttribute('data-opened-by-mouse');
        }
      }
    };


    icon.addEventListener('mouseenter', () => {
      const cartLayer = findCartLayer();
      
      if (cartLayer && !cartLayer.hasAttribute('data-opened-by-keyboard')) {
        clearHoverTimeout();
        
        // layer activate
        cartLayer.classList.add('active');
        cartLayer.setAttribute('data-opened-by-mouse', 'true');
        
        if (!cartLayer.hasAttribute('data-cart-hover-events')) {
          cartLayer.addEventListener('mouseenter', () => {
            clearHoverTimeout();
          });

          cartLayer.addEventListener('mouseleave', (e) => {
            // verify if mouse is leaving the cart layer and container
            if (!container.contains(e.relatedTarget)) {
              closeCartLayer(100);
            }
          });

          cartLayer.setAttribute('data-cart-hover-events', 'true');
        }
      }
    });

    icon.addEventListener('mouseleave', (e) => {
      if (!container.contains(e.relatedTarget)) {
        closeCartLayer(200);
      }
    });

    container.addEventListener('mouseenter', () => {
      clearHoverTimeout();
    });

    container.addEventListener('mouseleave', () => {
      closeCartLayer(100);
    });
  }

  initKeyboardNavigation() {
    // management on keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        document.body.classList.add('using-keyboard');
      }
    });

    document.addEventListener('mousedown', () => {
      document.body.classList.remove('using-keyboard');
    });

    // open/close management for keyboard navigation
    this.keyboardToggleButtons.forEach(button => {
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const targetSelector = button.getAttribute('data-keyboard-toggle');

          let targetElement;
          if (targetSelector === 'l-quick-account') {
            targetElement = button.closest('.c-m-h__actions__desk-account').querySelector(`.${targetSelector}`);
          } else if (targetSelector === 'l-quick-cart') {
            targetElement = button.closest('.c-m-h__actions__desk-mini-cart').querySelector(`.${targetSelector}`);
          }

          if (targetElement) {
            const isOpen = targetElement.classList.contains('active');
            
            if (!isOpen) {
              // Aggiungi classe active e marca come aperto da tastiera
              targetElement.classList.add('active');
              targetElement.setAttribute('data-opened-by-keyboard', 'true');
              
              // Implementa il trap focus
              this.#setupTrapFocus(targetElement, button);
              
              // Focus al primo elemento
              setTimeout(() => {
                const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
                const firstFocusable = targetElement.querySelector(focusableSelector);
                if (firstFocusable) {
                  firstFocusable.focus();
                }
              }, 100);
            } else {
              // Chiudi se era aperto da tastiera
              if (targetElement.hasAttribute('data-opened-by-keyboard')) {
                targetElement.classList.remove('active');
                targetElement.removeAttribute('data-opened-by-keyboard');
                this.#removeTrapFocus(targetElement);
                button.focus();
              }
            }
          }
        }
      });
    });

    // Chiudi i layer aperti da tastiera o mouse quando si clicca fuori
    document.addEventListener('click', (e) => {
      const keyboardLayers = document.querySelectorAll('[data-opened-by-keyboard="true"]');
      const mouseLayers = document.querySelectorAll('[data-opened-by-mouse="true"]');
      
      keyboardLayers.forEach(layer => {
        if (!layer.contains(e.target) && !e.target.closest('[data-keyboard-toggle]')) {
          layer.classList.remove('active');
          layer.removeAttribute('data-opened-by-keyboard');
          this.#removeTrapFocus(layer);
        }
      });

      mouseLayers.forEach(layer => {
        if (!layer.contains(e.target) && !e.target.closest('.c-m-h__actions__desk-account') && !e.target.closest('.c-m-h__actions__desk-mini-cart')) {
          layer.classList.remove('active');
          layer.removeAttribute('data-opened-by-mouse');
        }
      });
    });
  }

  #setupTrapFocus(layerElement, triggerButton) {
    // Usa la utility esistente per il trap focus
    const trapFocusHandler = trapFocusOnModal(layerElement);

    if (!trapFocusHandler) return;

    // Salva il riferimento per poterlo rimuovere in seguito
    layerElement._trapFocusHandler = trapFocusHandler;

    // Aggiungi listener per ESC
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        layerElement.classList.remove('active');
        layerElement.removeAttribute('data-opened-by-keyboard');
        this.#removeTrapFocus(layerElement);
        triggerButton.focus();
      }
    };

    layerElement._escapeHandler = escapeHandler;
    layerElement.addEventListener('keydown', escapeHandler);
  }

  #removeTrapFocus(layerElement) {
    if (layerElement._trapFocusHandler) {
      removeTrapFocusOnModal(layerElement, layerElement._trapFocusHandler);
      delete layerElement._trapFocusHandler;
    }

    if (layerElement._escapeHandler) {
      layerElement.removeEventListener('keydown', layerElement._escapeHandler);
      delete layerElement._escapeHandler;
    }
  }

  render() {
    super.render();
    this.handleStickyHeader();
    this.setCustomVar();
    this.listenResize();
    this.listenBurger();
    this.listenScroll();
    this.bindSearchBtnEvents();
    this.setMenuItems();
    this.bindEvents();
    this.handleBenefitBar();
    this.updateMinicart();
  }

  handleStickyHeader() {
    let _this = this;

    window.addEventListener('scroll', function () {
      let scrollDebounce = _.debounce(function () {

        let distanceFromTop = $(this).scrollTop();
        let isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (isDesktop) {
          if (distanceFromTop > $('.c-main-header').height()) {
            // FIXED CASE
            $('.c-m-h__main-section').addClass('fixed');
          } else {
            // NOT FIXED CASE
            $('.c-m-h__main-section').removeClass('fixed');
          }
          _this.setCustomVar();
        } else {
          if (distanceFromTop > $('.header-wrapper-custom').height()) {
            $('.c-m-h__main-section').addClass('fixed');
          } else {
            $('.c-m-h__main-section').removeClass('fixed');
          }
        }
      }, 300);
      scrollDebounce();
    })
  }

  handleBenefitBar() {
    let benefitPreference = Cookies.get('removeBenefitBar');
    if (benefitPreference === 'false' || benefitPreference == null) {
      $('.c-benefit-bar').show();
    }
    setTimeout(() => {
      $('.icon-close', '.c-benefit-bar').each((index, slide) => {
        $(slide).on('click', () => {
          Cookies.set('removeBenefitBar', true, { expires: 1 });
          $('.c-benefit-bar').hide();
        })
      })
    }, 1000);
  }

  listenResize() {
    window.addEventListener('resize', () => {
      this.headerHeight = this.$component.offsetHeight;
      this.setMenuItems();
      this.setCustomVar();
    });
  }

  setMenuItems() {
    this.menuItems = [];
    let items = this.$component.querySelectorAll(this.SELECTORS.menuItems);
    if (items && items.length > 0) {
      items.forEach(item => {
        let menuItem = new MenuItem(item, this.layersContainer);
        this.menuItems.push(menuItem);
      });
    }
  }

  hideSecondLvlNav() {
    if (this.menuItems.length < 1) {
      return;
    }
    this.menuItems.forEach(menuItem => {
      menuItem.hidePanel();
    });
  }

  listenScroll() {
    if (this.hpHero != null && this.benefitBar != null) {
      window.addEventListener('scroll', () => {
        let heroHeight = this.hpHero.offsetHeight;
        let barHeight = this.benefitBar.offsetHeight;
        let totalScroll = heroHeight + barHeight;
        if (window.scrollY > totalScroll) {
          this.setDivider();
        }
      });
    } else {
      this.setDivider();
    }
  }

  setDivider() {
    this.$component.classList.add(this.CSS_CLASSNAMES.divider);
  }

  setCustomVar() {
    const root = document.documentElement;
    if ($('.c-m-h__main-section').hasClass('fixed')) {
      root.style.setProperty(this.CSS_CUSTOMVARS.jsHeightHeader, `${58}px`);
    } else {
      root.style.setProperty(this.CSS_CUSTOMVARS.jsHeightHeader, `${this.headerHeight}px`);
    }
    root.style.setProperty(this.CSS_CUSTOMVARS.jsVh, `${window.innerHeight * 0.01}px`);
  }

  bindSearchBtnEvents() {
    if (this.searchBtn != null && this.searchBtn.length) {
      this.searchBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.open);
        });
      });
    }
    if (this.searchBtnMobile != null) {
      this.searchBtnMobile.addEventListener('click', () => {
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.open);
      });
    }
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.searchBtn.forEach(btn => {
        btn.disabled = true;
      });
      if (window.matchMedia("(max-width:1023px)").matches) {
        FixBody.block(window.scrollY);
      }
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      if (window.matchMedia("(max-width:1023px)").matches) {
        FixBody.unblock(window.scrollY);
      }
      this.searchBtn.forEach(btn => {
        btn.disabled = false;
      });
    });
  }

  listenBurger() {
    if (this.burgerMenu != null) {
      this.burgerMenu.addEventListener('click', () => {
        this.menuIsOpen
          ? this.$emit(this.$customEvents.MENU_EVENTS.hideMenu)
          : this.$emit(this.$customEvents.MENU_EVENTS.showMenu);
        this.menuIsOpen = !this.menuIsOpen;
      });
    }
  }

  updateMinicart() {
    // global
    let ctx = this;
    // params
    let ajaxUrl = this.minicartBtn[0].getAttribute('data-url');

    return doAjax({
      url: ajaxUrl,
      dataType: "html",
      success: function (resp) {
        ctx.log('Minicart updated...');
        // get the html
        let response = new DOMParser().parseFromString(resp, 'text/html');
        let newCartHtml = response.querySelectorAll(ctx.SELECTORS.minicartContent);
        // replace html
        ctx.minicartContent.forEach((minicart, index) => {
          minicart.innerHTML = newCartHtml[index] ? newCartHtml[index].innerHTML : newCartHtml[0].innerHTML;
        });
        // update cart counter
        ctx.updateQty();
        // trigger event
        ctx.$emit(ctx.$customEvents.MINICART_EVENTS.update, { content: newCartHtml });
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  updateQty(qty) {
    // globals
    let ctx = this;
    //
    if (this.minicartCount != null) {
      if (typeof qty === 'undefined') {
        qty = this.minicartCount[0].getAttribute("data-qty");
      }
      // check if i have quantity
      if (parseInt(qty, 10) > 0) {
        // if is already shown, remove and show then
        let countLive = false;
        this.minicartCount.forEach(count => {
          if (count.classList.contains(this.CSS_CLASSNAMES.minicartCounterLive)) countLive = true
        });
        if (countLive) {
          this.hideCounter();
          // wait a little bit, put html and show counter
          setTimeout(function () {
            // put updated counter html
            ctx.minicartCount.forEach(count => {
              count.innerHTML = qty;
            })
            // remove exiting class
            ctx.minicartCount.forEach(count => {
              count.classList.remove(ctx.CSS_CLASSNAMES.minicartCounterGoingOut);
            })
            // show counter
            ctx.showCounter();
          }, 350);
        } else {
          // put html and show counter
          this.minicartCount.forEach(count => {
            count.innerHTML = qty;
            if (this.minicartBtn) {
              this.minicartBtn.forEach(btn => {
                const baseLabel = btn.getAttribute('aria-label').replace(/\d+$/, '').trim();
                btn.setAttribute('aria-label', `${baseLabel} ${qty}`);
              });
            }
          })
          this.showCounter();
        }
        // class for button to show counter
        this.minicartBtn.forEach(btn => {
          btn.classList.remove(this.CSS_CLASSNAMES.minicartEmpty);
        });
        this.minicartBtn.forEach(btn => {
          btn.classList.add(this.CSS_CLASSNAMES.minicartFull);
        });
      } else {
        // class for button to hide counter
        this.minicartBtn.forEach(btn => {
          btn.classList.remove(this.CSS_CLASSNAMES.minicartFull);
        });
        this.minicartBtn.forEach(btn => {
          btn.classList.add(this.CSS_CLASSNAMES.minicartEmpty);
        });
      }
    }
  }

  showCounter() {
    // globals
    let ctx = this;
    // wait a little bit, then
    setTimeout(function () {
      ctx.minicartCount.forEach(count => {
        count.classList.add(ctx.CSS_CLASSNAMES.minicartCounterLive);
      })
    }, 350);
  }

  hideCounter() {
    // remove and add classes
    this.minicartCount.forEach(count => {
      count.classList.remove(this.CSS_CLASSNAMES.minicartCounterLive);
    })
    this.minicartCount.forEach(count => {
      count.classList.add(this.CSS_CLASSNAMES.minicartCounterGoingOut);
    })
  }

  openQuickCartNotification(button) {
    // global
    let ctx = this;
    // params
    let ajaxUrl = this.minicartBtn[0].getAttribute('data-link');
    let productCode = button.getAttribute('data-code') || button.getAttribute('data-product-code');
    // go ajax to open minicart controller
    return doAjax({
      url: ajaxUrl,
      data: {
        'productCode': productCode
      },
      dataType: "html",
      type: 'POST',
      success: function (resp) {
        ctx.log('Open Minicart...');
        let response = new DOMParser().parseFromString(resp, 'text/html');
        let quickCartHtml = response.querySelector(ctx.SELECTORS.minicartContent).innerHTML;
        // replace html
        ctx.minicartContentNotify.forEach(el => {
          el.innerHTML = quickCartHtml;
        })
        // open cart
        ctx.openMinicartNotification();
        setTimeout(function () {
          ctx.closeMinicartNotification();
        }, 5000);

        // minicart notification mobile (only in PdP)
        if (window.matchMedia("(max-width:1023px)").matches && ctx.minicartMobile) {
          ctx.minicartMobile.innerHTML = quickCartHtml;
          ctx.openMinicartNotificationMobile();

          setTimeout(function () {
            ctx.closeMinicartNotificationMobile();
          }, 3000);
        }
        // trigger event
        ctx.$emit(ctx.$customEvents.MINICART_EVENTS.update, { quickCartContent: response });
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  openMinicartNotification() {
    // global
    let ctx = this;
    setTimeout(function () {
      ctx.minicartContentNotify.forEach((minicart, i) => {
        minicart.classList.add(ctx.CSS_CLASSNAMES.minicartOpened);
        if (i === 0) {
          minicart.querySelector('[tabindex="0"]').focus();
        }
      })
      ctx.minicartContent.forEach(minicart => {
        minicart.classList.add(ctx.CSS_CLASSNAMES.minicartHidden);
      })
    }, 500);
  }

  closeMinicartNotification() {
    clearTimeout(this.timeout);
    this.minicartContentNotify.forEach(minicart => {
      minicart.classList.remove(this.CSS_CLASSNAMES.minicartOpened);
    })
    this.minicartContent.forEach(minicart => {
      minicart.classList.remove(this.CSS_CLASSNAMES.minicartHidden);
    })
    // empty the div
    this.minicartContentNotify.forEach(minicart => {
      minicart.innerHTML = '';
    })
  }

  openMinicartNotificationMobile() {
    // global
    let ctx = this;
    ctx.minicartMobile.classList.add('open');
    $('.l-quick-cart ', ctx.minicartMobile).addClass('open');
  }

  closeMinicartNotificationMobile() {
    // global
    let ctx = this;
    ctx.minicartMobile.classList.remove('open');
  }

  bindEvents() {
    let ctx = this;

    let scrollY;
    this.$on(this.$customEvents.MENU_EVENTS.showMenu, () => {
      this.burgerMenu.classList.add(this.CSS_CLASSNAMES.burgerOpen);
      this.$component.classList.add(this.CSS_CLASSNAMES.showMenu);
      let barHeight = this.benefitBar.offsetHeight;
      scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${barHeight}px`;
      document.body.style.width = '100%';
      this.setDivider();
    });
    this.$on(this.$customEvents.MENU_EVENTS.hideMenu, () => {
      this.burgerMenu.classList.remove(this.CSS_CLASSNAMES.burgerOpen);
      this.$component.classList.remove(this.CSS_CLASSNAMES.showMenu);
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      this.hideSecondLvlNav();
    });

    // update counter
    this.$on(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, ({ event, payload }) => {
      // only for first time on load page
      ctx.minicartCount.forEach(count => {
        count.classList.remove(ctx.CSS_CLASSNAMES.minicartVisible);
      })
      // on add to cart i want to update the counter
      // take the old, plus 1, put
      let oldQty = ctx.minicartCount[0].getAttribute("data-qty");
      let newQty = parseInt(oldQty, 10) + 1;
      ctx.minicartCount[0].dataset.qty = newQty;
      // launch update
      ctx.updateQty(newQty);
      // update the minicart
      this.updateMinicart();
      // show quick cart notification
      // update counter
      ctx.openQuickCartNotification(payload.button);
    });

    if (this.miniaccountEmail) {
      this.miniaccountEmail.forEach(emailInput => {
        emailInput.addEventListener('input', (e) => {
          let form = e.target.form;
          let submitButton = form.querySelector('#m_submit');
          if (emailInput.value && emailInput.value != '' && $('#m_password', form)[0].value && $('#m_password', form)[0].value != '') {
            submitButton.classList.remove('disabled');
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.classList.add('disabled');
            submitButton.setAttribute('disabled', 'disabled');
          }
        })
      })
    }

    if (this.miniaccountPwd) {
      this.miniaccountPwd.forEach(passwordInput => {
        passwordInput.addEventListener('input', (e) => {
          let form = e.target.form;
          let submitButton = form.querySelector('#m_submit');
          if ($('#m_username', form)[0].value && $('#m_username', form)[0].value != '' && passwordInput.value && passwordInput.value != '') {
            submitButton.classList.remove('disabled');
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.classList.add('disabled');
            submitButton.setAttribute('disabled', 'disabled');
          }
        })
      })

    }
  }

  // Metodo helper per gestire il ritorno del focus
  #returnFocusToKeyboardButton(targetType) {
    const keyboardButton = document.querySelector(`[data-keyboard-toggle="${targetType}"].keyboard-only`);
    if (keyboardButton && document.body.classList.contains('using-keyboard')) {
      keyboardButton.focus();
    } else {
      // Fallback per account
      if (targetType === 'l-quick-account') {
        const accountLink = document.querySelector('.c-m-h__actions__desk-account > a');
        if (accountLink) {
          accountLink.focus();
        } else {
          const fallbackFocusElement = document.querySelector(this.SELECTORS.wishlistLink);
          if (fallbackFocusElement) {
            fallbackFocusElement.focus();
          }
        }
      }
      // Fallback per minicart
      else if (targetType === 'l-quick-cart') {
        const minicartLink = document.querySelector('.c-m-h__actions__desk-mini-cart > a');
        if (minicartLink) {
          minicartLink.focus();
        }
      }
    }
  }
}
